import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerDocumentiBancariModalComponent} from './worker-documenti-bancari-modal';

export const WorkerDocumentiBancariModalModule: string = ng
    .module('worker-documenti-bancari-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDocumentiBancariModalComponent', WorkerDocumentiBancariModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-documenti-bancari-modal/worker-documenti-bancari-modal.module.ts